import * as Colors from 'material-ui/styles/colors';

export default {
  dialogBody: {
    padding: 0,
    fontSize: 16,
    color: Colors.grey600,
    width: 870,
    maxWidth: 870,
  },
  dialogContent: {
    width: 870,
    maxWidth: 870,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 500,
    width: '100%',
    position: 'relative',
    justifyContent: 'space-between',
    paddingTop: 20,
    paddingBottom: 20,
    '@media screen and (max-height: 570px)': {
      height: 300,
    },
    '@media screen and (max-height: 670px) and (min-height: 571px)': {
      height: 400,
    },
  },
  closeIcon: {
    color: Colors.grey600,
    position: 'absolute',
    top: 10,
    right: 10,
  },
  button: {
    width: 230,
    position: 'relative',
  },
  image: {
    maxHeight: 125,
    '@media screen and (max-height: 570px)': {
      display: 'none',
    },
    '@media screen and (max-height: 670px) and (min-height: 571px)': {
      maxHeight: 75,
    },
  },
  imageContainer: {
    width: '100%',
    textAlign: 'center',
  },
};
